"use strict";
/*
 * Created on 15.02.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../../../user/conversions/UserInfoConverter");

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");

var EntityChangeSetInfo_1 = require("../EntityChangeSetInfo");
/**
 * @author MSu
 */


var EntityChangeSetInfoConverterImpl =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(EntityChangeSetInfoConverterImpl, _DataObjectConverter_);

  function EntityChangeSetInfoConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, EntityChangeSetInfoConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityChangeSetInfoConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(EntityChangeSetInfoConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new EntityChangeSetInfo_1.EntityChangeSetInfo(conversions.documentToClassId(source), source.user !== null ? this.userInfoConverter.toObject(source.user, conversions) : null, conversions.toDate(source.changeDate), source.changeType, source.entityClass, source.oldState, source.newState);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        user: source.user !== null ? this.userInfoConverter.toDocument(source.user, conversions) : null,
        changeDate: conversions.fromDate(source.changeDate),
        changeType: source.changeType,
        entityClass: source.entityClass,
        oldState: source.oldState,
        newState: source.newState
      });
      return result;
    }
  }]);

  return EntityChangeSetInfoConverterImpl;
}(DataObjectConverter_1.DataObjectConverter);

EntityChangeSetInfoConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], EntityChangeSetInfoConverterImpl);
exports.EntityChangeSetInfoConverterImpl = EntityChangeSetInfoConverterImpl;